import React from 'react';
import { useGameOnline, providerOnline, fmtOnline } from './gameOnline'; // [2026-11-05] กำลังเล่น

const TabGameHome = ({ categorylist, slotlist, sportlist, checkurl }) => {
    const online = useGameOnline();
    const badge = (pt) => providerOnline(online, pt) > 0 ? (<span className="sb-online" title="ผู้เล่นใน 5 วันล่าสุด"><i className="sb-online-dot" />{fmtOnline(providerOnline(online, pt))}<em className="sb-online-unit">คน</em></span>) : null;
    return (
        <>
            <div className="m-bg-title text-white-v1">

                <div className="clearfix bg-index-button example animated animatedFadeInUp fadeInUp ">
                    <div className="m-0 d-flex justify-content-between pt-1 pb-1 align-items-center">
                        <div className="d-flex justify-content-start w-100 align-items-center">
                            <div>
                                <img
                                    className="img-title-games-hot"
                                    src="https://cdn.javisx.com/image/8f441725-8089-4ac7-b2c6-f35617eb77ce.png"
                                    alt=""
                                />
                            </div>

                            <div className="p-1 title-pannel-game color4 w-100">
                                <div className="-bg-container">
                                    <img
                                        width={850}
                                        height={877}
                                        src="/build/web/igame-index-lobby-wm/img/lightning001.png"
                                        className="image wp-image-2101  attachment-full size-full"
                                        alt=""
                                        style={{ maxWidth: "100%", height: "auto" }}
                                        decoding="async"
                                        srcSet="/build/web/igame-index-lobby-wm/img/lightning001.png 850w, https://idea-bet.live/theme/harem789/wp-content/uploads/2022/06/lightning001-291x300.png 291w, https://idea-bet.live/theme/harem789/wp-content/uploads/2022/06/lightning001-768x792.png 768w, https://idea-bet.live/theme/harem789/wp-content/uploads/2022/06/lightning001-24x24.png 24w, https://idea-bet.live/theme/harem789/wp-content/uploads/2022/06/lightning001-36x36.png 36w"
                                        sizes="(max-width: 850px) 100vw, 850px"
                                    />
                                    <img
                                        width={500}
                                        height={412}
                                        src="/build/web/igame-index-lobby-wm/img/tab-index-roulette.png"
                                        className="image wp-image-2080  attachment-full size-full"
                                        alt=""
                                        style={{ maxWidth: "100%", height: "auto" }}
                                        decoding="async"
                                        srcSet="/build/web/igame-index-lobby-wm/img/tab-index-roulette.png 500w, https://idea-bet.live/theme/harem789/wp-content/uploads/2022/06/tab-index-roulette-300x247.png 300w, https://idea-bet.live/theme/harem789/wp-content/uploads/2022/06/tab-index-roulette-24x20.png 24w, https://idea-bet.live/theme/harem789/wp-content/uploads/2022/06/tab-index-roulette-36x30.png 36w, https://idea-bet.live/theme/harem789/wp-content/uploads/2022/06/tab-index-roulette-48x40.png 48w"
                                        sizes="(max-width: 500px) 100vw, 500px"
                                    />
                                    <img
                                        width={1392}
                                        height={771}
                                        src="/build/web/igame-index-lobby-wm/img/bg_index_element_03.png"
                                        className="image wp-image-2077  attachment-full size-full"
                                        alt=""
                                        style={{ maxWidth: "100%", height: "auto" }}
                                        decoding="async"
                                        srcSet="/build/web/igame-index-lobby-wm/img/bg_index_element_03.png 1392w, https://idea-bet.live/theme/harem789/wp-content/uploads/2022/06/bg_index_element_03-300x166.png 300w, https://idea-bet.live/theme/harem789/wp-content/uploads/2022/06/bg_index_element_03-1024x567.png 1024w, https://idea-bet.live/theme/harem789/wp-content/uploads/2022/06/bg_index_element_03-768x425.png 768w, https://idea-bet.live/theme/harem789/wp-content/uploads/2022/06/bg_index_element_03-24x13.png 24w, https://idea-bet.live/theme/harem789/wp-content/uploads/2022/06/bg_index_element_03-36x20.png 36w, https://idea-bet.live/theme/harem789/wp-content/uploads/2022/06/bg_index_element_03-48x27.png 48w"
                                        sizes="(max-width: 1392px) 100vw, 1392px"
                                    />
                                    <img
                                        width={1505}
                                        height={812}
                                        src="/build/web/igame-index-lobby-wm/img/bg_index_element_04.png"
                                        className="image wp-image-2078  attachment-full size-full"
                                        alt=""
                                        style={{ maxWidth: "100%", height: "auto" }}
                                        decoding="async"
                                        srcSet="/build/web/igame-index-lobby-wm/img/bg_index_element_04.png 1505w, https://idea-bet.live/theme/harem789/wp-content/uploads/2022/06/bg_index_element_04-300x162.png 300w, https://idea-bet.live/theme/harem789/wp-content/uploads/2022/06/bg_index_element_04-1024x552.png 1024w, https://idea-bet.live/theme/harem789/wp-content/uploads/2022/06/bg_index_element_04-768x414.png 768w, https://idea-bet.live/theme/harem789/wp-content/uploads/2022/06/bg_index_element_04-24x13.png 24w, https://idea-bet.live/theme/harem789/wp-content/uploads/2022/06/bg_index_element_04-36x19.png 36w, https://idea-bet.live/theme/harem789/wp-content/uploads/2022/06/bg_index_element_04-48x26.png 48w"
                                        sizes="(max-width: 1505px) 100vw, 1505px"
                                    />{" "}
                                </div>

                                <span className="text-title-popular">
                                    คาสิโนออนไลน์ ยอดนิยม
                                </span>
                            </div>
                        </div>

                    </div>
                </div>

            </div>
            <div className="text-white-v1">
                <div className="pt-1 pb-1 text-white-v1">
                    <div className="x-category-provider js-game-scroll-container js-game-container">
                        <div className="-games-list-container container">
                            <nav className="nav-menu" id="navbarProvider">
                                <ul className="nav nav-pills row animated animatedFadeInUp fadeInUp ">

                                    {categorylist
                                        .map((listitem, i) => (
                                            <li key={i} className="col-6 col-lg-2 col-md-3 nav-item -random-container -game-casino-macro-container p-1 pb-0 mb-2" typetext="" >
                                                <a href="/"
                                                    onClick={(e) => {
                                                        checkurl(e, "/listgameall/casino/" + listitem.partner)
                                                    }} >
                                                    <div
                                                        className="x-game-list-item-macro js-game-list-toggle -big -cannot-entry -untestable example bg-card-item"
                                                        data-status="-cannot-entry -untestable bg-card-item"
                                                    >
                                                        <div className="-inner-wrapper card-width-banner-games">
                                                            {badge(listitem.partner)}
                                                            <div />
                                                            <picture>
                                                                <img alt=""
                                                                    role="button"
                                                                    className="w-100 hover-slot hoverTextCss"
                                                                    loading="lazy"
                                                                    decoding="async"
                                                                    src={listitem.image}
                                                                />
                                                            </picture>
                                                            <div className="-overlay d-none d-lg-block">
                                                                <div className="-overlay-inner">
                                                                    <div className="-wrapper-container">
                                                                        <button role="button"
                                                                            onClick={(e) => {
                                                                                checkurl(e, "/listgameall/casino/" + listitem.partner)
                                                                            }}

                                                                            className="-btn v-login js-account-approve-aware"  >
                                                                            <svg
                                                                                xmlns="http://www.w3.org/2000/svg"
                                                                                width={20}
                                                                                height={20}
                                                                                fill="currentColor"
                                                                                className="bi bi-play-circle-fill m-2"
                                                                                viewBox="0 0 16 16"
                                                                            >
                                                                                <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM6.79 5.093A.5.5 0 0 0 6 5.5v5a.5.5 0 0 0 .79.407l3.5-2.5a.5.5 0 0 0 0-.814l-3.5-2.5z" />
                                                                            </svg>
                                                                            <span className="-text-btn">เข้าเล่น</span>
                                                                        </button>

                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div>
                                                            <div></div>
                                                        </div>
                                                    </div>
                                                </a>
                                            </li>
                                        ))}
                                </ul>
                            </nav>
                        </div>
                    </div>
                </div>
            </div>
            <div className="m-bg-title text-white-v1">
                <div className="clearfix bg-index-button example animated animatedFadeInUp fadeInUp ">
                    <div className="m-0 d-flex justify-content-between pt-1 pb-1 align-items-center">
                        <div className="d-flex justify-content-start w-100 align-items-center">
                            <div>
                                <img
                                    className="img-title-games-hot"
                                    src="https://cdn.javisx.com/image/3742cf82-9809-42a8-8d6c-7d6a708cce2d.png"
                                    alt=""
                                />
                            </div>
                            <div className="p-1 title-pannel-game color4 w-100">
                                <span className="text-title-popular">สล็อตยอดนิยม</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="text-white-v1 animated animatedFadeInUp fadeInUp ">
                <div className="pt-1 pb-1 text-white-v1">
                    <div className="x-category-provider js-game-scroll-container js-game-container">
                        <div className="-games-list-container container">
                            <nav className="nav-menu" id="navbarProvider">
                                <ul className="nav nav-pills row animated animatedFadeInUp fadeInUp ">
                                    {slotlist.map((listitem, i) => (
                                        <li key={i} className="col-6 col-lg-2 col-md-3 nav-item -random-container -game-casino-macro-container p-1 pb-0 mb-2" typetext=""
                                        >
                                            <a href="/"
                                                onClick={(e) => {
                                                    checkurl(e, "/listgameall/slot/" + listitem.partner)
                                                }}
                                            >
                                                <div
                                                    className="x-game-list-item-macro js-game-list-toggle -big -cannot-entry -untestable example bg-card-item"
                                                    data-status="-cannot-entry -untestable bg-card-item"
                                                >
                                                    <div className="-inner-wrapper card-width-banner-games">
                                                        {badge(listitem.partner)}
                                                        <div />
                                                        <picture>
                                                            <img alt=""
                                                                role="button"
                                                                className="w-100 hover-slot hoverTextCss"
                                                                loading="lazy" decoding="async" /* [2026-10-27] เดิมเขียนผิด (lazy="loading") = รูปโหลดทันทีทุกใบ */
                                                                src={listitem.image}
                                                            />
                                                        </picture>
                                                        <div className="-overlay d-none d-lg-block">
                                                            <div className="-overlay-inner">
                                                                <div className="-wrapper-container">
                                                                    <button role="button"
                                                                        onClick={(e) => {
                                                                            checkurl(e, "/listgameall/slot/" + listitem.partner)
                                                                        }}

                                                                        className="-btn v-login js-account-approve-aware" >
                                                                        <svg
                                                                            xmlns="http://www.w3.org/2000/svg"
                                                                            width={20}
                                                                            height={20}
                                                                            fill="currentColor"
                                                                            className="bi bi-play-circle-fill m-2"
                                                                            viewBox="0 0 16 16"
                                                                        >
                                                                            <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM6.79 5.093A.5.5 0 0 0 6 5.5v5a.5.5 0 0 0 .79.407l3.5-2.5a.5.5 0 0 0 0-.814l-3.5-2.5z" />
                                                                        </svg>
                                                                        <span className="-text-btn">
                                                                            เข้าสู่ระบบ
                                                                        </span>
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div>
                                                        <div></div>
                                                    </div>
                                                </div>
                                            </a>
                                        </li>
                                    ))}

                                </ul>
                            </nav>
                        </div>
                    </div>
                </div>
            </div>




            <div className="m-bg-title text-white-v1">
                <div className="clearfix bg-index-button example animated animatedFadeInUp fadeInUp ">
                    <div className="m-0 d-flex justify-content-between pt-1 pb-1 align-items-center">
                        <div className="d-flex justify-content-start w-100 align-items-center">
                            <div>
                                <img
                                    className="img-title-games-hot"
                                    src="https://cdn.javisx.com/image/3742cf82-9809-42a8-8d6c-7d6a708cce2d.png"
                                    alt=""
                                />
                            </div>
                            <div className="p-1 title-pannel-game color4 w-100">
                                <span className="text-title-popular">กีฬายอดนิยม</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="text-white-v1 animated animatedFadeInUp fadeInUp ">
                <div className="pt-1 pb-1 text-white-v1">
                    <div className="x-category-provider js-game-scroll-container js-game-container">
                        <div className="-games-list-container container">
                            <nav className="nav-menu" id="navbarProvider">
                                <ul className="nav nav-pills row animated animatedFadeInUp fadeInUp ">
                                    {sportlist.map((listitem, i) => (
                                        <li key={i} className="col-6 col-lg-2 col-md-3 nav-item -random-container -game-casino-macro-container p-1 pb-0 mb-2" typetext=""
                                        >
                                            <a href="/"
                                                onClick={(e) => {
                                                    checkurl(e, "/listgameall/slot/" + listitem.partner)
                                                }}
                                            >
                                                <div
                                                    className="x-game-list-item-macro js-game-list-toggle -big -cannot-entry -untestable example bg-card-item"
                                                    data-status="-cannot-entry -untestable bg-card-item"
                                                >
                                                    <div className="-inner-wrapper card-width-banner-games">
                                                        {badge(listitem.partner)}
                                                        <div />
                                                        <picture>
                                                            <img alt=""
                                                                role="button"
                                                                className="w-100 hover-slot hoverTextCss"
                                                                loading="lazy" decoding="async" /* [2026-10-27] เดิมเขียนผิด (lazy="loading") = รูปโหลดทันทีทุกใบ */
                                                                src={listitem.image}
                                                            />
                                                        </picture>
                                                        <div className="-overlay d-none d-lg-block">
                                                            <div className="-overlay-inner">
                                                                <div className="-wrapper-container">
                                                                    <button role="button"
                                                                        onClick={(e) => {
                                                                            checkurl(e, "/listgameall/slot/" + listitem.partner)
                                                                        }}

                                                                        className="-btn v-login js-account-approve-aware" >
                                                                        <svg
                                                                            xmlns="http://www.w3.org/2000/svg"
                                                                            width={20}
                                                                            height={20}
                                                                            fill="currentColor"
                                                                            className="bi bi-play-circle-fill m-2"
                                                                            viewBox="0 0 16 16"
                                                                        >
                                                                            <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM6.79 5.093A.5.5 0 0 0 6 5.5v5a.5.5 0 0 0 .79.407l3.5-2.5a.5.5 0 0 0 0-.814l-3.5-2.5z" />
                                                                        </svg>
                                                                        <span className="-text-btn">
                                                                            เข้าสู่ระบบ
                                                                        </span>
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div>
                                                        <div></div>
                                                    </div>
                                                </div>
                                            </a>
                                        </li>
                                    ))}

                                </ul>
                            </nav>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default TabGameHome;
